import * as _ from "lodash";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { StaffStatsService } from "../../services/staff-stats.service";

export const reportStaffOnline = createAsyncThunk(
  "staffStatsManage/reportStaffOnline",
  async (filter, { rejectWithValue }) => {
    try {
      const response = await StaffStatsService.reportStaffOnline(filter);

      return _.get(response, "data", {});
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
